import { ca } from '@cian/analytics';

interface IEventData {
  action: string;
  category: string;
  page: unknown;
  products: unknown;
  label: string;
}

export function trackUpsaleCarouselEvent(eventData: IEventData) {
  ca('eventSite', eventData);
}
